import { render, staticRenderFns } from "./reportTemplate.vue?vue&type=template&id=82152832&"
import script from "./reportTemplate.vue?vue&type=script&lang=ts&"
export * from "./reportTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./reportTemplate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports